import {
  put,
  putResolve,
  takeLatest,
  select,
  all,
  call,
  take,
} from 'redux-saga/effects';
import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import history from 'app/routes/history';
import _ from 'lodash';
import {
  CognitoLogin,
  CognitoLogout,
  CognitoForgotPassword,
  CognitoChangePassword,
} from 'app/utils/aws/awsCognito';
import jwtDecode from 'jwt-decode';
import { getAdmin } from 'app/ducks/admins/actions';
import { sagaActions } from 'app/ducks/authentication/actions';
import { getCurrentAdmin } from 'app/ducks/admins/selectors';
import { globalLoad } from 'app/ducks/global/actions';
import { isAuthenticated } from 'app/ducks/authentication/selectors';
import { resetOrganisations } from 'app/ducks/organisations/actions';
import { resetCompetitions } from 'app/ducks/competitions/actions';
import { AuthenticationActionTypes as types } from 'app/ducks/authentication/types';

function* refreshUserSaga(action): any {
  yield put(sagaActions.refreshUserSuccess(action.payload));
}

function* authenticateCognitoUserSaga(action): any {
  yield putResolve(sagaActions.authenticateCognitoUserPending());
  yield put(resetOrganisations());
  try {
    // const response = yield call(
    //   { context: Auth, fn: Auth.signIn },
    //   action.payload.user.email.toLowerCase(),
    //   action.payload.user.password,
    // );
    const response = yield call(CognitoLogin, {
      email: action.payload.user.email.toLowerCase(),
      password: action.payload.user.password,
    });
    const { jwtToken } = response.signInUserSession.idToken;
    const id = jwtDecode(jwtToken).sub;
    if (
      response.signInUserSession.idToken.payload['cognito:groups']
        !== undefined
      && _.includes(
        response.signInUserSession.idToken.payload['cognito:groups'],
        'teammo-admin',
      )
      && action.payload.user.organisationId === undefined
    ) {
      yield put(
        sagaActions.authenticateCognitoUserFailed('no organisation provided'),
      );
    }

    const { redirectLocation } = action.payload;
    // yield select(
    //   (state) => state.authentication.redirectLocation,
    // );
    const redirect = redirectLocation !== undefined;

    if (redirect) {
      history.push(redirectLocation);
    }
    yield put(
      sagaActions.authenticateCognitoUserSuccess(
        response.signInUserSession,
        action.payload.user.organisationId,
      ),
    );

    if (action.payload.findUser) {
      yield put(getAdmin(id, !redirect));
    }
  } catch (error) {
    yield put(sagaActions.authenticateCognitoUserFailed(error.message));
  }
}

function* forgotPasswordSaga(action): any {
  yield put(sagaActions.forgotPasswordPending());
  try {
    yield call(CognitoForgotPassword, {
      email: action.payload.user.email.toLowerCase(),
    });
    yield put(
      sagaActions.forgotPasswordSuccess({
        email: action.payload.user.email.toLowerCase(),
      }),
    );
    history.push('/forgot-password/confirm');
  } catch (error) {
    yield put(sagaActions.forgotPasswordFailed(error.message));
  }
}

function* changePasswordSaga(action): any {
  yield put(sagaActions.changePasswordPending());
  try {
    const response = yield call(CognitoChangePassword, {
      email: action.payload.user.email.toLowerCase(),
      password: action.payload.user.password,
      verificationCode: action.payload.user.verificationCode,
    });
    yield put(sagaActions.changePasswordSuccess(response));
    setTimeout(() => {
      history.push('/login');
    }, 1000);
  } catch (error) {
    yield put(sagaActions.changePasswordFailed(error.message));
  }
}

function* logoutUserSaga(action): any {
  CognitoLogout();
  if (action.payload.redirect) {
    history.push('/login');
  }
  yield put(
    sagaActions.userLogout({
      redirectLocation: action.payload.redirectLocation,
    }),
  );
}

function* refreshOrLogoutUserSaga(action): any {
  yield put(sagaActions.authenticateCognitoUserPending());

  const refreshSuccessful = yield isAuthenticated();
  if (!refreshSuccessful) {
    CognitoLogout();

    yield put(
      sagaActions.authenticateCognitoUserFailed('Please login to continue.'),
    );

    if (action.payload.redirect) {
      history.push('/login');
    }
    yield put(
      sagaActions.userLogout({
        redirectLocation: action.payload.redirectLocation,
      }),
    );
  } else {
    const hardcodedOrgId = yield select(
      (state) => state.authentication.organisationId,
    );
    const admin = yield select((state) => getCurrentAdmin(state));
    const regularOrgId = admin.organisations[0] !== undefined
      ? admin.organisations[0].id
      : undefined;
    const orgId = _.isEmpty(hardcodedOrgId) ? regularOrgId : hardcodedOrgId;

    yield put(sagaActions.authenticateCognitoUserSuccess('Logged in.', orgId));
  }
}
function* switchOrganisationSaga(action): any {
  yield putResolve(resetCompetitions());
  yield put(globalLoad({}));
}

/* ********************************* SAGA WATCHERS ********************************* */

function* refreshUserSagaWatcher(): any {
  yield takeLatest(types.REFRESH_COGNITO_USER_REQUESTED, refreshUserSaga);
}

function* authenticateCognitoUserSagaWatcher(): any {
  yield takeLatest(
    types.AUTHENTICATE_COGNITO_USER_REQUESTED,
    authenticateCognitoUserSaga,
  );
}

function* forgotPasswordSagaWatcher(): any {
  yield takeLatest(types.FORGOT_PASSWORD_REQUESTED, forgotPasswordSaga);
}
function* changePasswordSagaWatcher(): any {
  yield takeLatest(types.CHANGE_PASSWORD_REQUESTED, changePasswordSaga);
}

function* logoutUserSagaWatcher(): any {
  yield takeLatest(types.USER_LOGOUT_REQUESTED, logoutUserSaga);
}
function* refreshOrLogoutUserSagaWatcher(): any {
  yield takeLatest(types.REFRESH_OR_LOGOUT_REQUESTED, refreshOrLogoutUserSaga);
}
function* switchOrganisationSagaWatcer(): any {
  yield takeLatest(types.SWITCH_ORGANISATION, switchOrganisationSaga);
}
export default function* root(): any {
  yield all([
    refreshUserSagaWatcher(),
    authenticateCognitoUserSagaWatcher(),
    forgotPasswordSagaWatcher(),
    changePasswordSagaWatcher(),
    logoutUserSagaWatcher(),
    refreshOrLogoutUserSagaWatcher(),
    switchOrganisationSagaWatcer(),
  ]);
}
